<template lang="pug">
  vm-prompt(@vm-cancel="close" @vm-accept="setAction" @vm-close="close" :vm-accept-text="$t('strings.accept')" :vm-cancel-text="$t('strings.cancel')" :vm-is-valid="!$v.form.$invalid " :vm-active="isModalSetOrderVisible" :vm-title='title')
    vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12")
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-input(v-model="form.order_customer" label='Folio de la Orden de Compra')
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          span {{ $t("quotations.purchase_order_file") }}
          input(type="file", ref="purchase_order_file", v-on:change="handlePoUpload()", accept="application/pdfapplication/msword, image/jpeg, image/x-png, application/pdf, application/vnd.openxmlformats-officedocument.wordprocessingml.document")
</template>

<script>
import { required, requiredIf } from 'vuelidate/lib/validators'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('Quotations')

export default {
  name: 'ModalQuotationsSetOrder',
  props: {
    form: {
      default: () => [],
      type: Object
    },
    title: {
      type: String,
      default: 'Orden de compra del cliente'
    },
    id: {
      type: Number,
      default: 0
    }
  },
  validations: {
    form: {
      order_customer: {
        required
      },
      purchase_order_file: {
        required: requiredIf(function () { return this.fileValidate })
      }
    }
  },
  data: () => ({
    purchase_order_file: ''
  }),
  computed: {
    ...mapGetters([
      'isModalSetOrderVisible'
    ]),
    fileValidate () {
      return this.purchase_order_file.length < 1
    }
  },
  methods: {
    ...mapActions([
      'setOrderQuotation',
      'actionQuotation',
      'setModalPurchaseOrderVisible'
    ]),
    async setAction () {
      await this.setOrderQuotation({ id: this.id, form: this.form, purchase_order_file: this.purchase_order_file }).then(() => {
        this.actionQuotation({ id: this.id, action: 'sold' })
      })
    },
    close () {
      this.setModalPurchaseOrderVisible(false)
    },
    handlePoUpload () {
      this.purchase_order_file = this.$refs.purchase_order_file.files[0]
    }
  }
}
</script>

<style>
.vm-select--options {
  z-index: 400331 !important;
}
a {
  cursor: pointer;
}
</style>
